import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/research/resources/page-client.tsx");
